import React from 'react';
import { ThemeProvider, Box, Typography, Button, Container, Link as MuiLink } from '@mui/material';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import AppRoutes from './routes';
import { isLoggedIn } from './utils/auth';
import { useLogoutMutation } from './redux/services/authApi';
import { theme } from './theme';
import { AuthProvider, useAuth } from './context/AuthContext';

const AppContent = () => {
  const [logout] = useLogoutMutation();
  const { setUser } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.removeItem('user');
      setUser(null);
      window.location.href = '/';
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <Router>
      <Box component="nav" sx={{ bgcolor: 'primary.main', color: 'white', p: 2 }}>
        <Container
          sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center' 
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Typography level="h1" component="h1" sx={{ color: 'white', fontWeight: 'bold' }}>
              Salebot Connector
            </Typography>
            {isLoggedIn() && (
              <>
                <MuiLink component={Link} to="/" color="inherit" underline="hover">
                  Home
                </MuiLink>
                <MuiLink component={Link} to="/faq-categories" color="inherit" underline="hover">
                  FAQ Categories
                </MuiLink>
                <MuiLink component={Link} to="/faq" color="inherit" underline="hover">
                  FAQ
                </MuiLink>
                <MuiLink component={Link} to="/clients" color="inherit" underline="hover">
                  Clients
                </MuiLink>
                <MuiLink component={Link} to="/settings" color="inherit" underline="hover">
                  Settings
                </MuiLink>
                <MuiLink component={Link} to="/stop-words" color="inherit" underline="hover">
                  Stop Words
                </MuiLink>
                <MuiLink component={Link} to="/accounts" color="inherit" underline="hover">
                  Accounts
                </MuiLink>
                <MuiLink component={Link} to="/agents" color="inherit" underline="hover">
                  Agents
                </MuiLink>
                <MuiLink component={Link} to="/chatwoot-teams" color="inherit" underline="hover">
                  Teams
                </MuiLink>
                <MuiLink component={Link} to="/history" color="inherit" underline="hover">
                  History
                </MuiLink>
                <MuiLink component={Link} to="/users" color="inherit" underline="hover">
                  Users
                </MuiLink>
                <MuiLink component={Link} to="/profile" color="inherit" underline="hover">
                  Profile
                </MuiLink>
              </>
            )}
            {!isLoggedIn() && (
              <MuiLink component={Link} to="/login" color="inherit" underline="hover">
                Login
              </MuiLink>
            )}
          </Box>
          {isLoggedIn() && (
            <Button color="inherit" onClick={handleLogout}>
              Logout
            </Button>
          )}
        </Container>
      </Box>
      <Container sx={{ mt: 4, maxWidth: '97% !important'}}>
        <AppRoutes />
      </Container>
    </Router>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;